import React, { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cx from 'classnames';
import { useTheme } from '@mui/material';

const SortableItem = ({ item, render, itemIndex, id, className, helperClass, disabled }) => {
  const { attributes, isDragging, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    disabled,
  });

  const cursor = (disabled && 'auto') || (isDragging ? 'grabbing' : 'grab');

  const style = {
    zIndex: isDragging ? 1 : 0,
    transform: CSS.Translate.toString(transform),
    transition,
    userSelect: 'none',
    cursor,
    minWidth: 0,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={className}
      {...attributes}
      {...listeners}
      {...(isDragging && { 'data-order': 'last' })}
    >
      {render(
        {
          ...(item.toJS ? item.toJS() : item),
          className: cx({ 'dnd-dragging': isDragging, [helperClass]: isDragging }),
          style: { cursor },
          idx: itemIndex,
          dragging: isDragging,
        },
        itemIndex,
      )}
    </div>
  );
};

export default memo(SortableItem);
